import { setActiveTab } from 'utils/actions/active-tab/active-tab.actions';

import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import fetchGamesEnding from 'dashboard/resources/games-ending.api';

import template from './games-ending.html';

const mapStateToThisContactUsBase = ({ ui, session, config, dictionary }) => {
  const { retailer, locale } = session;
  const { endingGamesActiveTab: activeTab } = ui;
  const { endReturnsUsed, endSalesUsed, endValidationsUsed } = config;

  const terms = dictionary.terms[locale];

  return {
    terms,
    retailer,
    activeTab,
    endSalesUsed,
    endReturnsUsed,
    endValidationsUsed,
  };
};

const mapDispatchToThis = {
  setActiveTab,
};

const tabs = {
  endSales: 'endSales',
  endValidations: 'endValidations',
  endReturns: 'endReturns',
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state')
class GamesEndingWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThisContactUsBase, mapDispatchToThis)(this);

    this.tabs = tabs;
    this.fetchGamesEnding = fetchGamesEnding;
  }

  $onInit() {
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.isLoading = true;

    this.fetchGamesEnding(retailerId)
      .then((data) => {
        this.isLoading = false;
        this.data = data;
        this.isEmpty = this.data.endSales === null && this.data.endReturns === null && this.data.endValidations === null;

        this.setTab();
      })
      .catch(() => {
        this.isLoading = false;
        this.isEmpty = false;
        this.isMaintenance = true;
      });
  }

  setTab() {
    switch (true) {
      case this.data.endSales !== null && this.endSalesUsed:
        this.setActiveTab(this.tabs.endSales, 'endingGamesActiveTab');
        break;
      case this.data.endValidations !== null && this.endValidationsUsed:
        this.setActiveTab(this.tabs.endValidations, 'endingGamesActiveTab');
        break;
      case this.data.endReturns !== null && this.endReturnsUsed:
        this.setActiveTab(this.tabs.endReturns, 'endingGamesActiveTab');
        break;
      default:
        this.setActiveTab('', 'endingGamesActiveTab');
    }
  }

  $onDestroy() {
    this.setActiveTab('', 'endingGamesActiveTab');
    this.unsubscribe();
  }
}

export default class GamesEndingWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = GamesEndingWidgetController;
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/games-ending/games-ending-component.js